import React from 'react';
import { Form, Select } from 'antd';
import { Field } from '@src/components/Common/Form';

const SCHEDULE_OPTIONS = [
    { value: 'none', label: 'No automatic schedule' },
    { value: '0 * * * *', label: 'Every hour' },
    { value: '0 0 * * *', label: 'Every day' },
    { value: '0 0 * * 1', label: 'Every week' },
    { value: '0 0 1 * *', label: 'Every month' },
];

/**
 * When an optimiser runs on its own. The API keeps the flag and the expression
 * apart, so picking a frequency sets both: no schedule means no flag either.
 */
const OptimiserForm = () => {
    const form = Form.useFormInstance();

    return (
        <>
            <Form.Item name={['extra_data', 'schedule_enabled']} hidden initialValue={false}>
                <input type="hidden" />
            </Form.Item>

            <Field
                name={['extra_data', 'schedule_crontab']}
                label="Schedule"
                span={3}
                hint="How often this optimiser runs on its own."
                initialValue="none"
                // "none" is the picker's way of saying no schedule; the form stores null
                normalize={(value) => (value === 'none' ? null : value)}
                getValueProps={(value) => ({ value: value ?? 'none' })}
            >
                <Select
                    placeholder="Select frequency"
                    options={SCHEDULE_OPTIONS}
                    onChange={(value) =>
                        form.setFieldValue(['extra_data', 'schedule_enabled'], !!value && value !== 'none')
                    }
                />
            </Field>
        </>
    );
};

export default OptimiserForm;
